import React from 'react'
import { useMutation } from "react-query";
import { api } from "./../../../../../../api/index";
import { exams } from "./../../../../../../api/exams";
import ScaleLoader from "./../../../components/ScaleLoader";
import { AssessementContext } from '../../../AssessmentContext';
import { toast } from "react-hot-toast";
import { useTranslation } from 'react-i18next';

const UnsuspiciousActivityModal = ({SetShowUnusualModal}) => {
  const { t } = useTranslation();
  const { assessment, setAssessment } = React.useContext(AssessementContext);
  const {mutateAsync, isLoading} = useMutation(exams.logViolation)

  const unsupportedActions = [
    t('minimize-browser'),
    t('resize-browser'),
    t('open-new-tab'),
    t('open-new-program'),
    t('ctrl-c'),
    t('ctrl-v'),
    t('print-screen'),
    t('f12'),
  ];

  const flagAssessmentMutation = useMutation(api.flagAssessment,{
     onSuccess: (data) => {
         if(data?.termination){
            setAssessment({...assessment, isTerminated:true})
         }
     },
     onError: (data) => {
        toast.error(t('error-unknown'))
     }
  });

  const takeActionOnUnusualActivity = async () => {
      SetShowUnusualModal(false)
      const isTestEnvironment = window.Cypress  
      if(process.env.NODE_ENV === 'production' || isTestEnvironment){
        //enforce full screen
        if(!isTestEnvironment){
          const element = document.documentElement; // Get the root element of the document
        if (element.requestFullscreen) {
        element.requestFullscreen();
        } else if (element.mozRequestFullScreen) { /* Firefox */
        element.mozRequestFullScreen();
        } else if (element.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
        element.webkitRequestFullscreen();
        } else if (element.msRequestFullscreen) { /* IE/Edge */
        element.msRequestFullscreen();
        }
        }
        //send candidate activity to the backend
       /* flagAssessmentMutation.mutate({
          user_group_id:  JSON.parse(
               window.sessionStorage.getItem('submit-assessment-payload')
               ).user_group_id,
          reason: "candidate activity was suspicious.",
          assessment_id: JSON.parse(
            window.sessionStorage.getItem('submit-assessment-payload')
            ).assessment_id
       })*/
      try{
          const res = await mutateAsync({ 
            userExamId: JSON.parse(sessionStorage.getItem('active-assessment'))?.user_exam_id,
            payload: { type: sessionStorage.getItem('frudeType')}
        })
        if(res?.data?.terminate){
            setAssessment({...assessment, isTerminated:true})
         }
      }catch(error){
        //toast.error('')
       }
    }    
  }

  if(JSON.parse(sessionStorage.getItem('active-assessment') || '{}')?.require_booking){
    return null
  }

  return (

    <div className='h-[100vh] w-[100vw] bg-[rgba(0,0,0,0.3)] fixed top-0 left-0' style={{ zIndex:9000000}}>
         { flagAssessmentMutation.isLoading && <ScaleLoader /> }         
        <div className='w-full h-full -mt-8 md:mt-0 flex items-center p-0 m-0 justify-center'>
             <div className='bg-white w-[98%] md:w-[40%] h-[470px] rounded-lg'>
             <div className="shadow-lg flex flex-shrink-0 items-center justify-between rounded-t-md border-b-2 border-neutral-100 border-opacity-100 p-4 dark:border-opacity-50">           
                <h5 className="text-2xl font-medium leading-normal text-gray-900" id="exampleModalLabel">
                    {t('unusual-activity')}               
                    <span className='block text-md md:text-lg font-normal'>
                        {t('system-check')}
                    </span>
                </h5>                     
             </div>         
             <div className="relative flex-auto p-4" data-te-modal-body-ref>
                <p className='text-md md:text-xl text-red-500 mt-4 mb-5'>
                    {t('suspicious-activity')}
                </p>
                <ul>
                {
                    unsupportedActions.map((unsupportedAction, id) => (
                        <li key={id} className='mt-3 text-md md:text-lg capitalize flex items-center'>
                            <span className='text-md md:text-xl text-red-500 bi bi-exclamation-triangle ml-3 mr-2'></span>
                            {unsupportedAction}
                        </li>
                    ))
                }
                </ul>
                {/*<p className='mt-3 md:mt-5 text-lg'>
                    {t('activity-warning')}
                </p>*/}
             </div>        
             <div className="flex flex-shrink-0 flex-wrap items-center bg-red-100 justify-end rounded-b-md border-t-2 border-neutral-100 border-opacity-100 p-4 dark:border-opacity-50">
                <button
                    type="button"
                    disabled={isLoading} data-test-id="violation-submit-button"
                    className="inline-block rounded bg-red-500 px-6 pb-2 pt-2.5 text-xs font-medium uppercase leading-normal text-white transition duration-150 ease-in-out focus:outline-none focus:ring-0"
                    onClick={takeActionOnUnusualActivity}          
                >
                    { isLoading ? <LoaderIcon /> : t('ok-understand')}
                </button>           
             </div>
             </div>
        </div>         
    </div>
  )
}

export default UnsuspiciousActivityModal